import { DiscoverFields } from "./fields";

export const fieldsConfig = {
  cardHolderDetails: {
    fields: [
      {
        fieldObject: DiscoverFields.cardholderName,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cardholderAddress,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cardholderCountryCode,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cardholderState,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cardholderCity,
        isRequired: false
      },

      {
        fieldObject: DiscoverFields.cardholderPostalCode,
        isRequired: false
      },
      {
        fieldObject: DiscoverFields.cardholderPhoneNumber,
        isRequired: false
      }
    ]
  },
  caseNote: {
    fieldObject: DiscoverFields.caseNote,
    isRequired: false
  }
};



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/commonFieldsConfig.js